import { CSRF_COOKIE } from "./constants";

export function readCookie(cookieString: string, name: string): string | null {
  for (const part of cookieString.split(";")) {
    const [key, ...value] = part.trim().split("=");
    if (key === name) return decodeURIComponent(value.join("="));
  }
  return null;
}

/** Unsafe cookie-authenticated requests carry the readable CSRF cookie value in X-CSRF-Token (ADR-0042). */
export const isUnsafeMethod = (method: string) => !["GET", "HEAD", "OPTIONS"].includes(method.toUpperCase());

export function csrfToken(): string | null {
  return typeof document === "undefined" ? null : readCookie(document.cookie, CSRF_COOKIE);
}
